
export { default as Footer } from "./Organisms/Footer"